import { Grid, SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { useState } from 'react';

type IconProps = {
  color?: string;
  hoverColor?: string;
  style?: React.CSSProperties;
  props?: any;
};

const CopyLinkIcon = ({ color = RoutalPalette.neutral00, hoverColor, style, props }: IconProps) => {
  const [isHover, setHover] = useState(false);
  return (
    <Grid onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <SvgIcon
        {...props}
        viewBox="0 0 17 17"
        style={{ width: `17px`, height: `17px`, color: isHover && hoverColor ? hoverColor : color, style }}
      >
        <g>
          <path d="M15.55,6.71l-2.86-4.04c-.31-.44-.83-.71-1.37-.71H4.45c-.97,0-1.75,.79-1.75,1.75V14.84c0,.97,.79,1.75,1.75,1.75H14.1c.97,0,1.75-.79,1.75-1.75V7.68c0-.35-.11-.69-.31-.97Zm-1.62-.01h-1.55c-.22,0-.41-.18-.41-.41V3.94l1.95,2.76Zm.18,8.59H4.45c-.24,0-.44-.2-.44-.44V3.71c0-.24,.2-.44,.44-.44h6.21v3.01c0,.95,.77,1.72,1.72,1.72h2.16v6.83c0,.24-.2,.44-.44,.44Z" />
          <path d="M12.9,.69c0-.36-.29-.66-.66-.66H2.43C1.46,.03,.68,.82,.68,1.79V14.89c0,.36,.29,.66,.66,.66s.66-.29,.66-.66V1.79c0-.24,.2-.44,.44-.44H12.24c.36,0,.66-.29,.66-.66Z" />
        </g>
      </SvgIcon>
    </Grid>
  );
};

export default CopyLinkIcon;
